import { render, staticRenderFns } from "./ProductCommentById.vue?vue&type=template&id=b010ee7c&scoped=true&"
import script from "./ProductCommentById.vue?vue&type=script&lang=js&"
export * from "./ProductCommentById.vue?vue&type=script&lang=js&"
import style0 from "./ProductCommentById.vue?vue&type=style&index=0&id=b010ee7c&lang=scss&scoped=true&"
import style1 from "./ProductCommentById.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b010ee7c",
  null
  
)

export default component.exports